import React from "react";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Metadata } from "../../../Models/userEvaluationRequests";
import color from "../../../Constants/colors";
import { useTranslation } from "react-i18next";

interface MetadataModalProps {
  open: boolean;
  onClose: () => void;
  metadata: Metadata | null;
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const MetadataModal: React.FC<MetadataModalProps> = ({
  open,
  onClose,
  metadata,
}) => {
  const { t } = useTranslation("actionLog");
  if (!metadata) return null;
  const metadataEntries = Object.entries(metadata).filter(
    ([key, value]) => value !== null && value !== undefined && key !== "grade"
  );

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="metadata-modal-title">
      <Box sx={modalStyle}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            id="metadata-modal-title"
            color={color.primary_dark}
            variant="h6"
            component="h2"
          >
            {t("logs.modalTitle")}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <TableContainer
          component={Paper}
          sx={{ maxHeight: 400, overflowY: "auto" }}
        >
          <Table size="small" aria-label="evaluation metadata table">
            <TableBody>
              {metadataEntries.map(([key, value]) => (
                <TableRow
                  key={key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      color: color.primary_dark,
                      width: "40%",
                    }}
                  >
                    {key}
                  </TableCell>
                  <TableCell align="right" sx={{ color: color.primary_dark }}>
                    {Array.isArray(value)
                      ? value.join(", ") || "None"
                      : String(value)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};

export default MetadataModal;
